module.exports = __webpack_public_path__ + "media/images/dashboard/kinrgy_banner_card-b6757d8b2b1c915a1cc47331be5472ef.jpg";